(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  const SHOW_DELAY_MS = 150;
  const SAFETY_HIDE_MS = 8000;
  let overlay = null;
  let showTimer = null;
  let safetyTimer = null;
  let isShowing = false;

  function getOverlay() {
    if (overlay && overlay.isConnected) return overlay;
    overlay = document.getElementById('PageLoader');
    return overlay;
  }

  function clearTimers() {
    if (showTimer !== null) {
      window.clearTimeout(showTimer);
      showTimer = null;
    }
    if (safetyTimer !== null) {
      window.clearTimeout(safetyTimer);
      safetyTimer = null;
    }
  }

  function hide() {
    clearTimers();
    isShowing = false;
    const el = getOverlay();
    if (!el) return;
    el.classList.remove('is-visible');
    el.setAttribute('aria-hidden', 'true');
  }

  function show(immediate) {
    if (window.Shopify && window.Shopify.designMode) return;
    const el = getOverlay();
    if (!el || isShowing) return;

    clearTimers();
    isShowing = true;

    const reveal = function () {
      showTimer = null;
      el.classList.add('is-visible');
      el.setAttribute('aria-hidden', 'false');
    };

    if (immediate) {
      reveal();
    } else {
      showTimer = window.setTimeout(reveal, SHOW_DELAY_MS);
    }

    safetyTimer = window.setTimeout(hide, SAFETY_HIDE_MS);
  }

  function isModifiedClick(event) {
    return (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    );
  }

  function shouldHandleLink(anchor, event) {
    if (!anchor || isModifiedClick(event)) return false;
    if (anchor.hasAttribute('download')) return false;
    if (anchor.closest('[data-no-loading]')) return false;
    if (anchor.getAttribute('data-no-loading') !== null) return false;

    const target = (anchor.getAttribute('target') || '').toLowerCase();
    if (target && target !== '_self') return false;

    const href = anchor.getAttribute('href');
    if (!href || href === '#' || href.charAt(0) === '#') return false;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return false;
    }

    if (url.protocol === 'mailto:' || url.protocol === 'tel:' || url.protocol === 'javascript:') {
      return false;
    }
    if (url.origin !== window.location.origin) return false;

    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    ) {
      return false;
    }

    return true;
  }

  function shouldHandleForm(form, event) {
    if (!form || event.defaultPrevented) return false;
    if (form.closest('[data-no-loading]')) return false;
    if (form.getAttribute('data-no-loading') !== null) return false;

    const method = (form.getAttribute('method') || 'get').toLowerCase();
    if (method !== 'get') return false;

    const target = (form.getAttribute('target') || '').toLowerCase();
    if (target && target !== '_self') return false;

    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      const anchor = event.target.closest('a[href]');
      if (!shouldHandleLink(anchor, event)) return;
      show(false);
    },
    false
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest('form');
      if (!shouldHandleForm(form, event)) return;
      show(false);
    },
    false
  );

  window.addEventListener('pageshow', function () {
    hide();
  });

  window.EpicPageLoader = {
    show: function (options) {
      show(Boolean(options && options.immediate));
    },
    hide: hide,
  };
})();
